import './alert-group.css';
export default {
  "alert": "pf-v6-c-alert",
  "alertGroup": "pf-v6-c-alert-group",
  "alertGroupItem": "pf-v6-c-alert-group__item",
  "alertGroupOverflowButton": "pf-v6-c-alert-group__overflow-button",
  "dirRtl": "pf-v6-m-dir-rtl",
  "modifiers": {
    "toast": "pf-m-toast",
    "offstageTop": "pf-m-offstage-top",
    "incoming": "pf-m-incoming",
    "offstageRight": "pf-m-offstage-right",
    "outgoing": "pf-m-outgoing"
  }
};